import { useMemo } from 'react';

import type { Transaction } from '@shared/transactions-types';

import { getOrderLinkUrl } from './getOrderLinkUrl';
import { useOrderLinks } from './useOrderLinks';

export function useTransactionsWithOrderLinks(transactions: Transaction[]): Transaction[] {
    const { data: orderLinks } = useOrderLinks(transactions);
    return useMemo(
        () =>
            transactions.map((transaction) => {
                const orderLink = orderLinks?.find(
                    ({ transactionId }) => transactionId === transaction.id,
                );
                const paymentOrderUrl = orderLink ? getOrderLinkUrl(orderLink) : undefined;
                return paymentOrderUrl ? { ...transaction, paymentOrderUrl } : transaction;
            }),
        [orderLinks, transactions],
    );
}
